import { render, staticRenderFns } from "./vozilo-pripadnost.editor.vue?vue&type=template&id=a871938c&"
import script from "./vozilo-pripadnost.editor.vue?vue&type=script&lang=ts&"
export * from "./vozilo-pripadnost.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports